<template>
  <footer class="footer">
    <div class="inner">
      <div class="grid">
        <div>
          <div class="heading">Useful Links</div>
          <ul>
            <li>
              <page-link to="/">Home Page</page-link>
            </li>
            <li v-if="mortgagesPage">
              <page-link :to="mortgagesPage.url">{{ mortgagesPage.name }}</page-link>
            </li>
            <li v-if="contactPage">
              <page-link :to="contactPage.url">{{ contactPage.name }}</page-link>
            </li>
          </ul>
        </div>
        <div>
          <div class="heading">Our Developments</div>
          <ul>
            <li>
              <router-link :to="propertiesPage.url">Current Sites</router-link>
            </li>
          </ul>
        </div>
        <div>
          <template v-if="informationPage && informationPage.subs && informationPage.subs.length">
            <div class="heading">{{ informationPage.name }}</div>
            <ul>
              <li v-for="sub in informationPage.subs" :key="sub.ItemID">
                <router-link :to="sub.url">{{ sub.name }}</router-link>
              </li>
            </ul>
          </template>
        </div>
        <div class="contact" v-if="misc">
          <router-link class="logo" to="/">
            <img src="../assets/logo.jpg" alt="LMH Estates" />
          </router-link>
          <div v-if="misc.doncaster_telephone">
            <a :href="'tel:' + misc.doncaster_telephone.replace(/ /g, '')" class="number"
              >Call Us: {{ misc.doncaster_telephone }}</a
            >
          </div>
          <div v-if="misc.email">
            <a :href="'mailto:' + misc.email" class="email">{{ misc.email }}</a>
          </div>
        </div>
      </div>
      <div class="legal">
        <page-link v-if="complaintsPage" :to="complaintsPage.url">{{ complaintsPage.name }}</page-link>
        <span v-if="complaintsPage && privacyPage">|</span>
        <page-link v-if="privacyPage" :to="privacyPage.url">{{ privacyPage.name }}</page-link>
        <span>&copy;</span> LMH Estates Ltd
        <template v-if="misc && misc.address">| Registered Office: {{ misc.address.replace(/[\n\r]/g, " ") }}</template>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "Footer",
  computed: {
    ...mapState([
      "misc",
      "informationPage",
      "mortgagesPage",
      "propertiesPage",
      "portfolioPage",
      "contactPage",
      "complaintsPage",
      "privacyPage"
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  background: #253e52;
  color: #fff;
  padding-top: 6rem;
}

.legal {
  text-align: center;
  font-size: 1.2rem;
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 2rem;
  clear: both;
  opacity: 0.6;
}

.legal span {
  display: inline-block;
  margin: 0 0.5rem;
  color: #d1ae54;
}

.social a {
  display: inline-block;
  padding: 0 1rem;
}

.social a:hover svg {
  transform: scale(1.1);
  transition: all 0.2s;
}

.facebook:hover {
  color: #49649f;
}

.twitter:hover {
  color: #00aff2;
}

.youtube:hover {
  color: #e52c27;
}

.heading {
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: #d1ae54;
}

.grid ul,
.grid li {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.grid li {
  margin-bottom: 0.5rem;
}

.grid li a:hover {
  opacity: 1;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.logo img {
  width: 10rem;
  margin-bottom: 2rem;
}

.contact {
  text-align: right;
}

.address {
  margin-top: 2rem;
  font-size: 1.2rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .grid > div {
    width: 23%;
    margin-right: 2%;
    float: left;
  }
}

@media screen and (max-width: 750px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .contact,
  .grid > div {
    text-align: center;
    padding-bottom: 3rem;
  }

  .grid li {
    display: inline-block;
    padding: 0 1rem;
  }

  .minor {
    text-align: center;
  }

  .minor img {
    float: none;
    margin-bottom: 0.5rem;
  }

  .minor ul {
    display: block;
  }
}
</style>
